/* 订单管理 */


/* 产品管理 */
// const Goods = () => import('../pages/goods-manage')


/* 业务管理 */
const Business = () => import('../pages/business')
const LeaseManage = () => import('../pages/business/lease-manage')
const ProjectManage = () => import('../pages/business/project-manage')
const ShopMall = () => import('../pages/business/shop-mall')
    /* 产品管理 */
    const GoodsManage = () => import('../pages/business/shop-mall/goods-manage')

const SupplyChain = () => import('../pages/business/supply-chain')
const StorageManage = () => import('../pages/business/storage-manage')

/* 系统管理 */
const System = () => import('../pages/system')
const SystemDevelop = () => import('../pages/system/system-develop')
const SystemActor = () => import('../pages/system/system-actor')
const SystemConfig = () => import('../pages/system/system-config')
    /* 字典管理 */
    const DictManage = () => import('../pages/system/system-config/dict-manage')
    /* 业务字典 */
    const BusinessData = () => import('../pages/system/system-config/business-data')
        /* 商品SKU */
        const GoodsDataSku = () => import('../pages/system/system-config/business-data/goods-data-sku')
    /* 树型字典 */
    const TreeData = () => import('../pages/system/system-config/tree-data')
        /* 模块树 */
        const ModuleTree = () => import('../pages/system/system-config/tree-data/module-tree')
        /* 分类树 */
        const TypeTree = () => import('../pages/system/system-config/tree-data/type-tree')

const SystemMenu = () => import('../pages/system/system-menu')

/* 资源管理 */
const Resource = () => import('../pages/resource')
const LittleWeb = () => import('../pages/resource/little-web')
const WebsiteManage = () => import('../pages/resource/website-manage')
const AppManage = () => import('../pages/resource/app-manage')
const SpaceManage = () => import('../pages/resource/space-manage')
const MaterialManage = () => import('../pages/resource/material-manage')

/* 主体管理 */
const ConductMain = () => import('../pages/conduct-main')
const PeopleManage = () => import('../pages/conduct-main/people-manage')
const OrganizeManage = () => import('../pages/conduct-main/organize-manage')

/* 组件管理 */
const Component = () => import('../pages/component')
const Archives = () => import('../pages/component/archives')
const Content = () => import('../pages/component/content')
const Credit = () => import('../pages/component/credit')
const Finance = () => import('../pages/component/finance')
const Hardware = () => import('../pages/component/hardware')
const OpenApi = () => import('../pages/component/open-api')
const ViewUi = () => import('../pages/component/view-ui')
const Vouchers = () => import('../pages/component/vouchers')

/* 需要权限判断的路由 */
const dynamicRoutes = [
    {
        path: '/business',
        component: Business,
        name: 'business',
        meta: {
            name: '业务管理',
            icon: 'icon-order-manage'
        },
        children: [
            {
                path: 'shop-mall',
                name: 'shop-mall',
                component: ShopMall,
                meta: {
                    name: '商城管理',
                    icon: 'icon-nav'
                },
                children: [
                    {
                        path: 'goods-manage',
                        name: 'goods-manage',
                        component: GoodsManage,
                        meta: {
                            name: '商品管理',
                            icon: 'icon-nav'
                        }
                    },
                    {
                        path: 'goods-manage',
                        name: 'goods-manage',
                        component: GoodsManage,
                        meta: {
                            name: '太空舱管理',
                            icon: 'icon-nav'
                        }
                    },
                    {
                        path: 'goods-manage',
                        name: 'goods-manage',
                        component: GoodsManage,
                        meta: {
                            name: '酒店管理',
                            icon: 'icon-nav'
                        }
                    }
                ]
            },
            {
                path: 'project-manage',
                name: 'project-manage',
                component: ProjectManage,
                meta: {
                    name: '项目管理',
                    icon: 'icon-home'
                }
            },
            {
                path: 'lease-manage',
                name: 'lease-manage',
                component: LeaseManage,
                meta: {
                    name: '租赁管理',
                    icon: 'icon-product-manage'
                }
            },
            {
                path: 'supply-chain',
                name: 'supply-chain',
                component: SupplyChain,
                meta: {
                    name: '供应链管理',
                    icon: 'icon-product-manage'
                }
            },
            {
                path: 'storage-manage',
                name: 'storage-manage',
                component: StorageManage,
                meta: {
                    name: '仓储管理',
                    icon: 'icon-product-manage'
                }
            }
        ]
    },
    {
        path: '/resource',
        component: Resource,
        name: 'resource',
        meta: {
            name: '资源管理',
            icon: 'icon-email'
        },
        children: [
            {
                path: 'little-web',
                name: 'little-web',
                component: LittleWeb,
                meta: {
                    name: '小程序管理',
                    icon: 'icon-quit'
                }
            },
            {
                path: 'website-manage',
                name: 'website-manage',
                component: WebsiteManage,
                meta: {
                    name: '网站管理',
                    icon: 'icon-service'
                }
            },
            {
                path: 'app-manage',
                name: 'app-manage',
                component: AppManage,
                meta: {
                    name: 'APP管理',
                    icon: 'icon-product-manage'
                }
            },
            {
                path: 'space-manage',
                name: 'space-manage',
                component: SpaceManage,
                meta: {
                    name: '空间管理',
                    icon: 'icon-product-manage'
                }
            },
            {
                path: 'material-manage',
                name: 'material-manage',
                component: MaterialManage,
                meta: {
                    name: '物料管理',
                    icon: 'icon-product-manage'
                }
            }
        ]
    },
    {
        path: '/system',
        component: System,
        name: 'system',
        meta: {
            name: '系统管理',
            icon: 'icon-order-manage'
        },
        children: [
            {
                path: 'system-actor',
                name: 'system-actor',
                component: SystemActor,
                meta: {
                    name: '主体管理',
                    icon: 'icon-nav'
                }
            },
            {
                path: 'system-develop',
                name: 'system-develop',
                component: SystemDevelop,
                meta: {
                    name: '全局开发',
                    icon: 'icon-nav'
                }
            },
            {
                path: 'system-config',
                name: 'system-config',
                component: SystemConfig,
                meta: {
                    name: '全局配置',
                    icon: 'icon-home'
                },
                children: [
                    {
                        path: 'dict-manage',
                        name: 'dict-manage',
                        component: DictManage,
                        meta: {
                            name: '数据字典',
                            icon: 'icon-nav'
                        }
                    },
                    {
                        path: 'business-data',
                        name: 'business-data',
                        component: BusinessData,
                        meta: {
                            name: '业务字典',
                            icon: 'icon-nav'
                        },
                        children: [
                            {
                                path: 'goods-data-sku',
                                name: 'goods-data-sku',
                                component: GoodsDataSku,
                                meta: {
                                    name: '商品SKU管理',
                                    icon: 'icon-nav'
                                }
                            }
                        ]
                    },
                    {
                        path: 'tree-data',
                        name: 'tree-data',
                        component: TreeData,
                        meta: {
                            name: '树型字典',
                            icon: 'icon-nav'
                        },
                        children: [
                            {
                                path: 'module-tree',
                                name: 'module-tree',
                                component: ModuleTree,
                                meta: {
                                    name: '模块树',
                                    icon: 'icon-nav'
                                }
                            },
                            {
                                path: 'type-tree',
                                name: 'type-tree',
                                component: TypeTree,
                                meta: {
                                    name: '分类树',
                                    icon: 'icon-nav'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: 'system-menu',
                name: 'system-menu',
                component: SystemMenu,
                meta: {
                    name: '功能列表',
                    icon: 'icon-product-manage'
                }
            }
        ]
    },
    {
        path: '/conduct-main',
        component: ConductMain,
        name: 'conduct-main',
        meta: {
            name: '主体管理',
            icon: 'icon-order-manage'
        },
        children: [
            {
                path: 'people-manage',
                name: 'people-manage',
                component: PeopleManage,
                meta: {
                    name: '人员管理',
                    icon: 'icon-nav'
                }
            },
            {
                path: 'organize-manage',
                name: 'organize-manage',
                component: OrganizeManage,
                meta: {
                    name: '组织管理',
                    icon: 'icon-home'
                }
            }
        ]
    },
    {
        path: '/component',
        component: Component,
        name: 'component',
        meta: {
            name: '组件管理',
            icon: 'icon-order-manage'
        },
        children: [
            {
                path: 'vouchers',
                name: 'vouchers',
                component: Vouchers,
                meta: {
                    name: '卡券模组',
                    icon: 'icon-nav'
                }
            },
            {
                path: 'credit',
                name: 'credit',
                component: Credit,
                meta: {
                    name: '积分模组',
                    icon: 'icon-home'
                }
            },
            {
                path: 'hardware',
                name: 'hardware',
                component: Hardware,
                meta: {
                    name: '硬件模组',
                    icon: 'icon-home'
                }
            },
            {
                path: 'open-api',
                name: 'open-api',
                component: OpenApi,
                meta: {
                    name: '对接模组',
                    icon: 'icon-home'
                }
            },
            {
                path: 'finance',
                name: 'finance',
                component: Finance,
                meta: {
                    name: '财务模组',
                    icon: 'icon-home'
                }
            },
            {
                path: 'archives',
                name: 'archives',
                component: Archives,
                meta: {
                    name: '档案模组',
                    icon: 'icon-home'
                }
            },
            {
                path: 'view-ui',
                name: 'view-ui',
                component: ViewUi,
                meta: {
                    name: '视图模组',
                    icon: 'icon-home'
                }
            },
            {
                path: 'content',
                name: 'content',
                component: Content,
                meta: {
                    name: '内容模组',
                    icon: 'icon-home'
                }
            }
        ]
    }
]

export default dynamicRoutes
